import React from 'react';
import { Link } from 'react-router-dom';
import styles from '../../landingPage/home.module.css';

function CommunityGuidelines() {
  return (
    <>
      {/* Header */}
      <section className={`${styles.header} ${styles.headerCs}`}>
        <div className={`container ${styles.container}`}>
          <div className={styles.logo}>
            <Link to="/">
              <img src={window.getPublicUrl("/images/logo-2.svg")} alt="ResuMate Logo" />
            </Link>
          </div>
          <div className={styles.social}>
            <ul className='terms-list'>
              <li><a href=""><img src={window.getPublicUrl("/images/insta.svg")} alt="Instagram" /></a></li>
              <li><a href=""><img src={window.getPublicUrl("/images/fb.svg")} alt="Facebook" /></a></li>
              <li><a href=""><img src={window.getPublicUrl("/images/tik.svg")} alt="TikTok" /></a></li>
            </ul>
          </div>
        </div>
      </section>

      {/* Main Content */}
      <main className="guidelines-container faq terms-nd-condition my-3" style={{ padding: '60px 0', minHeight: '70vh' }}>
   <div  className={`container ${styles.container}`}>
        <header className="guidelines-header">
          <h1 className='main-heading text-left'>Resumate Community Guidelines</h1>
          <p>
            Resumate is designed to help people build meaningful connections in a respectful, safe,
            and genuine way. To protect our community, we ask all members to follow these guidelines
            when using the app. By creating an account, you agree to abide by these rules.
          </p>
        </header>

        <article>
          <h2 className='inner-heading text-left'>1. Eligibility</h2>
          <ul className='terms-list'>
            <li>You must be at least 18 years old to use Resumate.</li>
            <li>We may request ID verification to confirm your age or identity if needed.</li>
          </ul>
        </article>

        <article>
          <h2 className='inner-heading text-left'>2. Profiles</h2>
          <ul className='terms-list'>
            <li>Be real: Your profile must represent you truthfully. No fake identities, impersonations, or misleading details.</li>
            <li>Photos: Upload only clear photos of yourself. Do not use heavily altered images, group-only photos, or pictures of children.</li>
            <li>Usernames: Choose a name that reflects who you are. Avoid offensive words, symbols, or pretending to be someone famous.</li>
          </ul>
        </article>

        <article>
          <h2 className='inner-heading text-left'>3. Respectful Behavior</h2>
          <ul className='terms-list'>
            <li>Treat others with kindness. No harassment, bullying, or intimidation.</li>
            <li>Discrimination, hate speech, or degrading language based on race, ethnicity, gender, sexuality, religion, or disability will not be tolerated.</li>
            <li>Unwanted sexual advances, explicit images, or fetishization are strictly prohibited.</li>
          </ul>
        </article>

        <article>
          <h2 className='inner-heading text-left'>4. Safety & Boundaries</h2>
          <ul className='terms-list'>
            <li>Never share or request explicit content, personal financial details, or banking information.</li>
            <li>Do not use Resumate to promote, sell, or exchange goods, services, substances, or donations.</li>
            <li>Threats, violence, exploitation, blackmail, or encouraging harmful acts will result in immediate removal.</li>
            <li>If someone makes you feel unsafe, use the Block & Report feature.</li>
          </ul>
        </article>

        <article>
          <h2 className='inner-heading text-left'>5. Authentic Connections</h2>
          <ul className='terms-list'>
            <li>Catfishing, misrepresentation, or creating multiple fake accounts are not allowed.</li>
            <li>Spamming, scams, pyramid schemes, or attempts to manipulate other members will result in suspension or removal.</li>
            <li>Automated tools, bots, or scripts interfering with the app are prohibited.</li>
          </ul>
        </article>

        <article>
          <h2 className='inner-heading text-left'>6. Mental Health & Wellbeing</h2>
          <ul className='terms-list'>
            <li>We support open and honest conversations about personal struggles, but content that promotes self-harm, suicide, or eating disorders is not allowed.</li>
            <li>If you or someone you know is struggling, please seek support from trusted professionals or local resources.</li>
          </ul>
        </article>

        <article>
          <h2 className='inner-heading text-left'>7. Prohibited Content</h2>
          <p>You may not share:</p>
          <ul className='terms-list'>
            <li>Private or identifying information of others without consent (doxxing).</li>
            <li>Misleading or stolen photos, deepfakes, or AI-generated impersonations.</li>
            <li>Content promoting political campaigning, fundraising, or commercial advertising.</li>
            <li>Any unlawful, fraudulent, or harmful content.</li>
          </ul>
        </article>

        <article>
          <h2 className='inner-heading text-left'>8. Reporting & Enforcement</h2>
          <ul className='terms-list'>
            <li>Our team reviews reports carefully and may take actions such as removing content, issuing warnings, temporarily suspending accounts or permanently banning accounts.</li>
            <li>In serious cases, we may cooperate with law enforcement.</li>
            <li>False reports made in bad faith may also lead to consequences.</li>
          </ul>
        </article>

        <article>
          <h2 className='inner-heading text-left'>9. Appeals</h2>
          <p>
            If you believe your account was suspended or banned in error, you may contact us at{" "}
            <a className='email' href="mailto:info@resumate.org">info@resumate.org</a> to request a review. While not all
            decisions may be reversed, we will fairly review your appeal.
          </p>
        </article>

        <article>
          <h2 className='inner-heading text-left'>10. Off-Platform Behavior</h2>
          <p>
            Respect doesn’t end when you log out. Harmful actions toward other members outside
            Resumate (such as on dates or through private messaging apps) can still affect your
            account status.
          </p>
        </article>

        <article>
          <h2 className='inner-heading text-left'>11. International Compliance</h2>
          <p>
            Resumate is available globally. You are responsible for following the laws of your
            country while using the app. Violations of local laws may result in suspension or
            account termination.
          </p>
        </article>

        <article>
          <h2 className='inner-heading text-left'>12. Our Commitment</h2>
          <p>
            We want Resumate to remain a positive and safe space. By using this app, you agree to
            follow these guidelines. Together, we can build a community based on honesty, respect,
            and meaningful connection.
          </p>
        </article>
</div>
      </main>

      {/* Footer */}
      <section className={styles.footer}>
        <div className={`container ${styles.container}`}>
          <div className="row">
            <div className="col-sm-4">
              <div className={styles.footerLeft}>
                <a href=""><img src={window.getPublicUrl("/images/footer-logo.svg")} /></a>
              </div>
                      <div className={`${styles.footerMid} ${styles.right}`}>
                <h4>Follow us</h4>
                <ul className='terms-list'>
                  <li><a href=""><img src={window.getPublicUrl("/images/footer-social1.svg")} /></a></li>
                  <li><a href=""><img src={window.getPublicUrl("/images/footer-social2.svg")} /></a></li>
                  <li><a href=""><img src={window.getPublicUrl("/images/footer-social3.svg")} /></a></li>
                </ul>
              </div>

            </div>
            <div className="col-sm-4">
                      <div>
                <ul className={styles.termsConditonList}>
                  <li><Link to="/terms&condition">Terms & Conditions</Link></li>
                  <li><Link to="/privacyPolicy">Privacy Policy</Link></li>
                  <li><Link to="/communityGuidelines">Community Guidelines</Link></li>
                  <li><Link to="/eula">EULA</Link></li>
                  <li><Link to="/safety">Safety</Link></li>
                </ul>
              </div>
            </div>
            <div className="col-sm-4">
                  <div className={styles.footerMid}>
                <h4 className="text-right">Get the app</h4>
                <ul className="text-right">
                  <li><a href="https://apps.apple.com/us/app/resumate-app/id6754164064
"><img src={window.getPublicUrl("/images/app2.svg")} /></a></li>
                  <li><a href="https://play.google.com/store/apps/details?id=com.resumate"><img src={window.getPublicUrl("/images/goog2.svg")} /></a></li>                </ul>
              </div>

            </div>
            <div className="col-sm-12">
              <h5>Copyright © 2025 Resumate.  All rights reserved.</h5>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default CommunityGuidelines;
